module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/credigas-estacionario/detalles/components/centro-consumo/centro-consumo.component.scss
// module id = ./src/app/creditos/credigas-estacionario/detalles/components/centro-consumo/centro-consumo.component.scss
// module chunks = main